import React from 'react';
import { EmailValidation, PasswordValidation } from 'utils/helper';
import { FormattedMessage } from 'react-intl';

const CheckValidation = (value, intl) => {
  const formError = {
    submit: true,
    email: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    password: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    confirmPassword: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    name: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    bussinessName: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    ownerName: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    specialistName: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    searchBussinessName: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    phoneNumber: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    categoryNameEn: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    categoryNameAr: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    subCategoryNameEn: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    subCategoryNameAr: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    serviceNameEn: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    serviceNameAr: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    image: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    country: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    city: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    bussinessEmail: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    bussinessPhoneNumber: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    price: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    timeRequired: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    serviceLocationType: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    campaignName: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    link: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    description: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    startDate: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    endDate: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    provider: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    category: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    associations: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    couponName: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    couponCode: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    startDateTime: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    endDateTime: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    postalCode: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    discountType: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    discountValue: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    conditionType: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    conditionValue: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    usage: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    branch: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    currency: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
    promotion_discounts: {
      error: false,
      errorMessage: <FormattedMessage id="field is required!" />,
    },
  };

  const emptyKeys = [];

  for (let key in value) {
    emptyKeys.push(key);
  }

  for (let i = 0; i < emptyKeys.length; i++) {
    if (!value[emptyKeys[i]]) {
      formError[emptyKeys[i]].error = true;
      formError.submit = false;
    }

    ////////category//////////////////////
    if (
      value[emptyKeys[i]] &&
      emptyKeys[i] === 'category' &&
      value[emptyKeys[i]]?.length <= 0
    ) {
      formError[emptyKeys[i]].error = true;
      formError.submit = false;
    }
    ////////category//////////////////////

    ////////provider//////////////////////
    if (
      value[emptyKeys[i]] &&
      emptyKeys[i] === 'provider' &&
      value[emptyKeys[i]]?.length <= 0
    ) {
      formError[emptyKeys[i]].error = true;
      formError.submit = false;
    }
    ////////provider//////////////////////

    ////////associations//////////////////////
    if (
      value[emptyKeys[i]] &&
      emptyKeys[i] === 'associations' &&
      value[emptyKeys[i]]?.length <= 0
    ) {
      formError[emptyKeys[i]].error = true;
      formError.submit = false;
    }
    ////////associations//////////////////////

    if (
      value[emptyKeys[i]] &&
      emptyKeys[i] === 'email' &&
      !EmailValidation(value[emptyKeys[i]])
    ) {
      formError[emptyKeys[i]].error = true;
      formError.submit = false;
      formError[emptyKeys[i]].errorMessage = (
        <FormattedMessage id="Please Enter Valid Email!" />
      );
    }

    if (value[emptyKeys[i]] && emptyKeys[i] === 'password') {
      const passwordCheck = PasswordValidation(value[emptyKeys[i]]);
      if (!passwordCheck.isValid) {
        formError[emptyKeys[i]].error = true;
        formError.submit = false;
        // formError[emptyKeys[i]].errorMessage = 'Please Enter Valid Password';
        const translatedMissing = passwordCheck.missing.map((key) =>
          intl.formatMessage({ id: key })
        );
        const message =
          translatedMissing.length > 0
            ? `${intl.formatMessage({ id: 'Missing' })}: ${translatedMissing.join(', ')}`
            : intl.formatMessage({ id: 'InvalidPassword' });

        formError[emptyKeys[i]].errorMessage = message;
      }
    }

    if (
      value[emptyKeys[i]] &&
      emptyKeys[i] === 'confirmPassword' &&
      !(value?.[emptyKeys[0]] === value?.[emptyKeys[1]])
    ) {
      formError[emptyKeys[i]].error = true;
      formError.submit = false;
      formError[emptyKeys[i]].errorMessage = (
        <FormattedMessage id="Password & Confirm Password Should be Same" />
      );
    }
  }
  return formError;
};

export default CheckValidation;
